<div class="item-inner">
  <div class="flex h-full w-full min-w-0 k-gap-1">
    <div class="header-content h-full w-full overflow-hidden">
      <div class="header-inner">
        @if (item().reserveable) {
          <div class="header-inner-icon" [class.green]="currentEvent() === null" [class.red]="currentEvent() !== null">
            @if (item().icon) {
              <cue-icon [icon]="item().icon" />
            } @else {
              <cue-icon [icon]="ICONS.cueQrCode" />
            }
          </div>
        } @else {
          @if (item().icon) {
            <div
              class="header-inner-icon"
              [class.green]="item().reserveable && currentEvent() === null"
              [class.red]="item().reserveable && currentEvent() !== null"
              [class.blue]="!item().reserveable"
            >
              <cue-icon [icon]="item().icon" />
            </div>
          } @else {
            <div
              class="header-inner-icon"
              [class.green]="item().reserveable && currentEvent() === null"
              [class.red]="item().reserveable && currentEvent() !== null"
              [class.blue]="!item().reserveable"
            >
              <cue-icon [icon]="ICONS.cueQrCode" />
            </div>
          }

          <!--                    <div class="header-inner-icon blue">-->
          <!--                        @if (item().file) {-->
          <!--                            <img-->
          <!--                                style="color: white"-->
          <!--                                loading="lazy"-->
          <!--                                [ngStyle]="{-->
          <!--                                    'object-position': item().imageObjectPosition,-->
          <!--                                }"-->
          <!--                                [class.img-cover]="item().imagePreferCover"-->
          <!--                                [class.category-icon]="item().fileExtension === 'svg'"-->
          <!--                                [src]="item().file | imageWidth: 'auto'"-->
          <!--                            />-->
          <!--                        } @else {-->
          <!--                            <cue-icon [icon]="ICONS.cueQrCode" />-->
          <!--                        }-->
          <!--                    </div>-->
        }

        <div class="header-inner-name">
          <div class="line-clamp-1" #targetABCTitleEl>
            <span class="display-name rendered-html" data-cy="concrete-target-abc">
              {{ (item().displayNameForApp | localizedString) ?? (item().name | localizedString) }}
            </span>
          </div>
          <!--<div class="relative max-h-11 flex overflow-hidden item-breadcrumb-wrapper">
                        <div
                            class="self-end item-breadcrumb"
                            [class.truncate]="targetABCTitleEl.offsetHeight > 30"
                            [class.rtl]="targetABCTitleEl.offsetHeight > 30"
                        >
                            @for (item of item().location; track item; let i = $index) {
                                @if (i > 0) {
                                    <span> > </span>
                                }
                                <span>{{ item | localizedString }}</span>
                            }
                        </div>
                    </div>-->
        </div>
      </div>
      <div
        class="poi-info-wrapper"
        [class.bordered]="item().reserveable"
        [class.green]="currentEvent() === null"
        [class.red]="currentEvent() !== null"
      >
        <div class="poi-info-inner">
          <div class="preview-image" [class.preview-image--bordered]="item().icon && item().file">
            @if (!item().file) {
              @if (item().qrCodes.length === 1) {
                @if (item().qrCodes[0].qrCategoryCodeId) {
                  <img [src]="item().qrCodes[0].qrCategoryCodeId | categoryIcon: categories() | imageWidth: 100" />
                } @else {
                  <cue-icon [icon]="ICONS.cueQrCode" (click)="requestNavigate.emit($event)" class="qr-img" />
                }
              } @else {
                <cue-icon [icon]="ICONS.cueQrCode" (click)="requestNavigate.emit($event)" class="qr-img" />
              }
            }
            @if (item().file && !item().reserveable) {
              <img
                loading="lazy"
                [ngStyle]="{
                  'object-position': item().imageObjectPosition,
                }"
                [class.img-cover]="item().imagePreferCover"
                [class.category-icon]="item().fileExtension === 'svg'"
                [src]="item().file | imageWidth: 100"
              />
            }
            <!--                    @if (item().icon && item().file) {-->
            <!--                        <div class="item-icon-wrapper">-->
            <!--                            <img class="item-icon" [src]="item().icon" />-->
            <!--                        </div>-->
            <!--                    }-->
          </div>
          @if (item().eventData.length > 0) {
            <div class="item-content">
              @if (currentEvent()) {
                <span class="subject">{{ item().eventData[0].subject }}</span>
                <div class="time-user">
                  <div class="time">
                    <cue-icon [icon]="ICONS.cueClock"></cue-icon
                    ><span class="red">{{ item().eventData[0].realStart | date: 'HH:mm' }}</span
                    >-<span>{{ item().eventData[0].realEnd | date: 'HH:mm' }}</span>
                  </div>
                  <div class="user">
                    <cue-icon [icon]="ICONS.cueUser"></cue-icon> {{ item().eventData[0].organizer }}
                  </div>
                </div>
              } @else {
                @if (freeTillDate()) {
                  <div class="time-user">
                    <div class="time">
                      <cue-icon [icon]="ICONS.cueClock"></cue-icon
                      ><span class="time-till"
                        ><span>{{ translation.reservationPanelApp.till | transloco }}</span
                        ><span>{{ freeTillDate() | date: 'HH:mm' }}</span></span
                      >
                    </div>
                  </div>
                } @else {
                  <cue-icon [icon]="ICONS.cueClock"></cue-icon
                  ><span class="red">{{ translation.scheduler.today | transloco }}</span>
                }
              }
            </div>
          } @else {
            <div class="poi-info">
              @if (item().reserveable) {
                <span class="status">{{ translation.reservationPanelApp.free | transloco }}</span>
                <div class="time-user">
                  <div class="time">
                    @if (freeTillDate()) {
                      <cue-icon [icon]="ICONS.cueClock"></cue-icon
                      ><span class="red">{{ translation.reservationPanelApp.till | transloco }}</span
                      >-<span>{{ freeTillDate() }}</span>
                    } @else {
                      <cue-icon [icon]="ICONS.cueClock"></cue-icon
                      ><span class="red">{{ translation.scheduler.today | transloco }}</span>
                    }
                  </div>
                </div>
              } @else {
                <div>
                  <span class="status resourceTypeName">{{ item().resourceTypeName | localizedString }}</span>
                  @if (!item().resourceId) {
                    <div class="category-name">{{ item().qrCodes[0].qrCategoryName | localizedString }}</div>
                  }
                </div>
              }
            </div>
          }
        </div>
      </div>
    </div>
  </div>
</div>
